import React, {ForwardedRef, forwardRef} from "react"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import FieldProto from "../../../../../../proto/field-proto"
import TasksViewManager from "../../../../../../../gd-modules/tasks-view/core/manager"
import FieldProto_updateView from "../../../../../../proto/render/table/function/update-view"
import {FieldViewSize} from "../../../../../../const"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    field           : FieldProto
    manager         : TasksViewManager

    onChange?       : callback
    onBlur          : callback
    onFocus?        : callback
}

const FieldCurrency_TableCellCalculated_EditValue = forwardRef(function(props: Props, ref: ForwardedRef<any>) {

    const onChange = (value:any) => {

        // if field has tableCellOnValueChange - use it !!!
        if (props.field.fieldParams.tableCellOnValueChange) {
            props.field.fieldParams.tableCellOnValueChange(props.listItem, value, props.manager)
            return
        }

        // Otherwise default = custom field



        // this is for custom fields (!!!)
        // system fields should have their own

        props.listItem.task.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.task.save()

        // need decide how to approach this ...
        // i guess some custom fields can do it (based ion type)
        // some not - it' about aggregation
        props.listItem.updateLastUpdateTime() // otherwise it wont re-render

        FieldProto_updateView(props.manager, props.field)
    }

    return (
        <div className="cell-flex p-h-0" style={props.style}>
            <props.field.renderComponents.editable
                ref         = {ref}
                size        = {FieldViewSize.SMALL}
                className   = "w-100-percent h-100-percent"
                disabled    = {props.manager.isReadOnly}
                field       = {props.field}
                model       = {props.listItem.item}
                onChange    = {props.onChange ? props.onChange : onChange}
                onBlur      = {props.onBlur}
                onFocus     = {props.onFocus}
            />
        </div>
    )
})

export default FieldCurrency_TableCellCalculated_EditValue
